let tertiaryMenus = document.querySelectorAll(".wp-block-navigation.is-style-solutions-tertiary");
tertiaryMenus.forEach( menu => {
	const currentItem = menu.querySelector('.current-menu-item > .wp-block-navigation-item__content');
	const labelText = currentItem ? currentItem.innerText : 'Select A Page';
	const menuList = menu.querySelector('ul').cloneNode(true);
	let mobileMenu = document.createRange().createContextualFragment('<nav class="tertiary-mobile-menu"><div class="nice-select selectize has-multiple" tabindex="0"><div class="multiple-options"><div class="current">' + labelText + '</div><div class="radix-caret-sort"></div></div><div class="nice-select-dropdown"></div></div></nav>');
	let mobileMenuDd = mobileMenu.querySelector('.nice-select-dropdown');
	mobileMenuDd.appendChild(menuList);
	menu.parentNode.appendChild(mobileMenu);
	let current = menu.parentNode.querySelector('.tertiary-mobile-menu .nice-select .multiple-options');
	current.addEventListener( 'click', e => {
		e.currentTarget.parentNode.classList.toggle('open');
	});
});
const niceSelects = document.querySelectorAll('.nice-select');
window.addEventListener('click', function(e){
	niceSelects.forEach( niceSelect => {
		if( ! niceSelect.contains(event.target ) ){
			niceSelect.classList.remove('open');
		}
	});
});
